const prefix = process.env.ASSET_PREFIX;

export const HOME = `${prefix}/`;

export const LOGIN = `${prefix}/recruiter-login`;

export const JOB_POSTING_FORM = `${prefix}/job-posting-form`;

export const CANDIDATE_LISTING = `${prefix}/candidate-listing`;

export const CONTACT_DETAILS = `${prefix}/contact-details`;

export const CLIENT_DETAILS = `${prefix}/client-details`;

export const EMAIL_VERIFICATION = `${prefix}/verify-email`;

export const REQUEST_EMAIL_VERIFICATION = `${prefix}/verify-request`;

export const DOCUMENT_VERIFICATION = `${prefix}/document-verification`;

export const VERIFY_PAGE = `${prefix}/verify`;

export const IRRELEVANT = `${prefix}/irrelevant-candidates`;

export const FAQ = `${prefix}/recruiter-faqs`;

export const DASHBOARD = `${prefix}/job-list`;

export const PROFILE = `${prefix}/profile`;

export const COOKIE_POLICY = "https://www.jobhai.com/cookie-policy";

export const TERMS_CONDITIONS = "https://www.jobhai.com/terms";

export const PRIVACY_POLICY = "https://www.jobhai.com/privacy";

export const CONTACT_US = "https://www.jobhai.com/contact-us";

export const ABOUT_US = "https://www.jobhai.com/about-us";

export const MANIFEST = "/hire/manifest.webmanifest";

export const SERVICE_WORKER = "/hire/rec-sw.js";

export const LOADING_PAGE = "/loading";

export const LANDING_PAGE = `${prefix}/landing-page`;
export const HELP_CENTRE = "/help-center";

const VERIFY_EMAIL = `${prefix}/verify-email`;
const CHECKOUT = `${prefix}/checkout`;

const PLAN_SELECTION = `${prefix}/plan-selection`;
const TRANSACTION_STATUS = `${prefix}/transaction-status`;
const TRANSACTION_HISTORY = `${prefix}/transaction-history`;
const JOB_PLAN_SELECTION = `${prefix}/job-plan-selection`;
const SELECT_JOB_PLAN = `${prefix}/select-job-plan`; // New V2 route
const JOB_ADD_QUESTIONS = `${prefix}/add-questions`;

const DATABASE_PRODUCT = `${prefix}/database-product`;
const TEAMS = `${prefix}/teams`;
const TEAMS_LOGS = `${prefix}/teams/logs`;
const OVERVIEW = `${prefix}/home`;
const TEAM_JOINING_FORM = `${prefix}/team-joining-form`;
const GO_TO_MARKET = `${prefix}/go-to-market`;
const WELCOME = `${prefix}/welcome`;
const WA_BROADCAST_CANDIDATE_SELECTION = `${prefix}/wa-broadcast-candidate-selection`;
const CREATE_BROADCAST = `${prefix}/create-broadcast`;
const VIEW_BROADCASTS = `${prefix}/view-broadcasts`;
const WHATSAPP_BROADCAST = `${prefix}/whatsapp-broadcast`;
const DOWNLOAD_CANDIDATES_CMP = `${prefix}/download-candidates/reco`;
const DOWNLOAD_CANDIDATES_DATABASE = `${prefix}/download-candidates/database`;
const BULK_UNLOCK_DATABASE = `${prefix}/bulk-unlock-candidates/database`;
const STANDALONE_DATABASE = `${prefix}/fynd-db`;
const BULK_UNLOCK_CMP = `${prefix}/bulk-unlock-candidates/reco`;
const SUPERBASE_SEARCH = `${prefix}/fynd-db/search`;
const VALIDATE_LINK = `${prefix}/validate-link`;
const OFFLINE_TRANSACTION_STATUS = `${prefix}/offline-transaction-status`;

export const Routes = {
  VERIFY_EMAIL,
  CANDIDATE_LISTING,
  CLIENT_DETAILS,
  CONTACT_DETAILS,
  DOCUMENT_VERIFICATION,
  EMAIL_VERIFICATION,
  REQUEST_EMAIL_VERIFICATION,
  IRRELEVANT,
  DASHBOARD,
  JOB_POSTING_FORM,
  PROFILE,
  CHECKOUT,
  PLAN_SELECTION,
  TRANSACTION_STATUS,
  TRANSACTION_HISTORY,
  TEAMS,
  TEAMS_LOGS,
  JOB_PLAN_SELECTION,
  SELECT_JOB_PLAN, // New V2 route
  LANDING_PAGE,
  HELP_CENTRE,
  DATABASE_PRODUCT,
  JOB_ADD_QUESTIONS,
  OVERVIEW,
  FAQ,
  TEAM_JOINING_FORM,
  GO_TO_MARKET,
  WELCOME,
  WA_BROADCAST_CANDIDATE_SELECTION,
  CREATE_BROADCAST,
  VIEW_BROADCASTS,
  WHATSAPP_BROADCAST,
  DOWNLOAD_CANDIDATES_CMP,
  DOWNLOAD_CANDIDATES_DATABASE,
  BULK_UNLOCK_DATABASE,
  BULK_UNLOCK_CMP,
  STANDALONE_DATABASE,
  SUPERBASE_SEARCH,
  VALIDATE_LINK,
  OFFLINE_TRANSACTION_STATUS
};

export const excludeFromLayoutRedirection = [REQUEST_EMAIL_VERIFICATION];
